import React from 'react';

function EmojiCard({ emoji, copied, onCopy }) {
  return (
    <div className="emoji-card" onClick={onCopy}>
      {/* Render the emoji character from its HTML code */}
      <div className="emoji-char" dangerouslySetInnerHTML={{ __html: emoji.htmlCode[0] }} />
      <div className="emoji-name">{emoji.name}</div>
      {copied && <div className="copied-label">Copied!</div>}
    </div>
  );
}

export default EmojiCard;
